import type { FormDataOf } from '../../../../../types/templates';
import { disneyEspnVS } from '..';
import { getMatchesForLeague } from './get-matches-for-league';
import { LEAGUE_CONFIGS } from './league-config';

type FormData = FormDataOf<typeof disneyEspnVS>;
type Option = { value: string; label: string };

// Dynamic team options driven by pre-configured matches for the picked league.
export const getDynamicMatchOptions = (
  fieldKey: string,
  formData: FormData,
  _creativityType?: string
): Option[] | undefined => {
  const { sport, league, round, team1 } = formData;

  if (!league || !LEAGUE_CONFIGS[league]) return undefined;

  const config = LEAGUE_CONFIGS[league];
  if (sport !== config.sport) return undefined;

  const matches = getMatchesForLeague(config.sport, league);
  if (!matches || matches.length === 0) return undefined;

  const filteredMatches = config.requiresRound && round ? matches.filter(m => m.round === round) : matches;

  if (fieldKey === 'team1') {
    const uniqueTeams = Array.from(new Set(filteredMatches.map(m => m.team1)));
    return uniqueTeams.map(team => ({ value: team, label: team.toUpperCase() }));
  }

  if (fieldKey === 'team2' && team1) {
    const validMatch = filteredMatches.find(m => m.team1 === team1);
    if (validMatch) return [{ value: validMatch.team2, label: validMatch.team2.toUpperCase() }];
  }

  return undefined;
};
